import axios from 'axios';
import { auth } from "@/firebase";
import { onAuthStateChanged } from "firebase/auth";

function waitForAuth() {
  return new Promise(resolve => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      unsubscribe(); // stop listening after first call
      resolve(user);
    });
  });
}

const axiosInstance = axios.create({
  //dev
  //baseURL: 'https://app-wvr4w37iiq-uc.a.run.app',
  
  //prod shohug-enterprise
  // baseURL: 'https://app-xjdogfn7lq-uc.a.run.app', 
  
  //prod shohug-enterprise-arafat
  // baseURL: 'https://app-tlkuhopbnq-uc.a.run.app/',
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  timeout: 1000000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor
axiosInstance.interceptors.request.use(
  async config => {
    const currentUser = await waitForAuth()
    // alert(currentUser)
    if (currentUser) {
      try {
        const token = await currentUser.getIdToken()
        config.headers.Authorization = token
        localStorage.setItem('authToken',token);
      } catch (err) {
        console.warn('Could not fetch Firebase token', err)
      }
    }
    return config
  },
  error => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status
    if (status === 401 || status === 500) {
      localStorage.removeItem('authToken')
      alert('You are logged out! Please login again.')
      window.location.assign('/')
    }
    return Promise.reject(error)
  }
);

export default axiosInstance;
